export default __webpack_public_path__ + "static/media/logo.7d0d5d24.png";